import React, { useState } from 'react';
import styled from 'styled-components';
import { GhostButton } from '../common/Button';
import { useAuth } from '../../context/AuthContext';
import { authService } from '../../services/authService';

const Bar = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 10000010;
    background: #b45309;
    color: #fff;
    padding: 8px 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 12px;
    font-size: 14px;
    font-weight: 600;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
`;

const ExitButton = styled(GhostButton).attrs({ $size: 'small' })`
    background: rgba(255, 255, 255, 0.15);
    border: 1px solid rgba(255, 255, 255, 0.4);
    color: #fff;

    &:hover:not(:disabled) {
        background: rgba(255, 255, 255, 0.25);
    }
`;

const Spacer = styled.div`
    height: 40px;
`;

export default function ImpersonationBanner() {
    const { currentUser } = useAuth();
    const [exiting, setExiting] = useState(false);

    if (!currentUser?.impersonatorId) return null;

    const handleExit = async () => {
        setExiting(true);
        try {
            await authService.exitImpersonation();
        } finally {
            // Full reload lands the user on the login route without any stale in-memory state.
            window.location.href = '/login';
        }
    };

    return (
        <>
            <Bar role="status" aria-live="polite">
                <span>
                    Impersonating <strong>@{currentUser.username}</strong> — actions taken here are audit-logged.
                </span>
                <ExitButton type="button" onClick={handleExit} disabled={exiting}>
                    {exiting ? 'Exiting…' : 'Exit impersonation'}
                </ExitButton>
            </Bar>
            <Spacer />
        </>
    );
}
